// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"383e4044","654":"c37080d2"}[chunkId] + ".chunk.css";
};